import React, {Component} from 'react';
// import '../../components/onboarding/SelectBubble.css';
import './AthOnboardingProducts.css';

class AthOnboardingProductsInfoWindow extends Component {
    
    render() {
      return(
        <div className="ath-products-window">
          <div className="ath-products-window__row">
            <span>Wash: </span> shampoo
          </div>
          <div className="ath-products-window__row">
            <span>Condition: </span>conditioner, hair mask, leave-in conditioner, hair treatments, cleansing conditioner
          </div>
          <div className="ath-products-window__row">
            <span>Dry and Protect: </span>heat protectant, hair moisturizing cream, sea salt spray
  style hair spray, hair mousse, hair gel, styling cream, wax, styling tool
          </div>
          <div className="ath-products-window__row">
            <span>Style: </span>hair spray, hair mousse, hair gel, styling cream, wax, styling tool
          </div>
          <div className="ath-products-window__row">
            <span>Refresh: </span>dry shampoo, combing cream, hair oil, hair serum
          </div>
        </div>
      );
    }
}

export default AthOnboardingProductsInfoWindow;



// WEBPACK FOOTER //
// ./src/ath/components/onboarding/AthOnboardingProductsInfoWindow.js